import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { OauthTokenDataObject } from 'models/service';

type LoginWithPasswordRequest = {
  /* eslint-disable @typescript-eslint/naming-convention -- Start: Keys are defined by Backend API endpoint */
  grant_type: 'password';
  join_community_id?: string;
  password: string;
  provider: 'local';
  username: string;
  /* eslint-enable @typescript-eslint/naming-convention -- End: Keys are defined by Backend API endpoint */
};

export const loginWithPassword = async (data: LoginWithPasswordRequest) =>
  apiClient.post<OauthTokenDataObject, ApiClientResponse<OauthTokenDataObject>>(routes.oauth.token, data, {
    skipAuth: true,
  });
